// import gate from '@gate/index';
import { commafy } from "@lib/index";
// import { prevUrlBeforAuth } from '@store/reducers/auth';
import Clock from "assets/svg/clock.svg";
import Profile from "assets/svg/newCourses/profile.svg";
import { Button } from "components";
// import Cookies from 'js-cookie';
import Link from "next/link";
// import { useRouter } from 'next/router';
// import { queryClient } from 'pages/_app';
import React, { FC } from "react";
// import { useDispatch } from 'react-redux';
// import { toast } from 'react-toastify';
import { convertToJalali, getClassFormat } from "src/utils";

import { Title } from "..";

type Props = {
  data: [
    {
      courseType: number;
      discount: number;
      endDate: string;
      id: number;
      image: string;
      title?: string;
      name: string;
      price: number;
      startDate: string;
      teacherNames: string;
      seoUrlDescription: string | undefined;
    }
  ];
};

const Prerequisites: FC<Props> = ({ data }) => {
  // const query = queryClient;
  // const dispatch = useDispatch();
  // const router = useRouter();

  // const { mutate, isLoading } = useMutation(gate.addOrder, {
  //     onSuccess: (data: any) => {
  //         if (data?.data?.isSuccessful) {
  //             query.invalidateQueries('order-list');
  //             toast.success(
  //                 data?.price == 0
  //                     ? 'این دوره به داشبورد شما اضافه شد'
  //                     : 'این سفارش به سبد خرید شما اضافه شد',
  //             );
  //         }
  //     },
  //     onError: (data: any) => {
  //         toast.error(data?.data?.message);
  //     },
  // });

  // const handlePay = ({
  //     price,
  //     discount,
  //     id,
  // }: {
  //     price: number;
  //     discount: number;
  //     id: number;
  // }) => {
  //     if (!Cookies.get('access_token')) {
  //         dispatch(prevUrlBeforAuth(router.asPath));
  //         router.push('/auth');
  //     } else {
  //         mutate({
  //             price,
  //             productType: 0,
  //             isInstallment: false,
  //             productId: +id,
  //             discount: discount ? discount : 0,
  //         });
  //     }
  // };
  return (
    <div
      className={`h-auto w-full rounded bg-transparent py-5 transition-all`}
      style={{
        contain: "content",
      }}
    >
      <div
        className={`relative flex w-full flex-col gap-y-6 rounded p-1 transition-all`}
        style={{ contain: "content" }}
      >
        <Title type="LINE" title="پیش نیازهای دوره" wrapperClass="mb-5" />
        {data?.map(
          ({
            courseType,
            discount,
            endDate,
            id,
            image,
            title,
            name,
            price,
            startDate,
            teacherNames,
            seoUrlDescription,
          }) => (
            <Link
              key={JSON.stringify(id)}
              href={{
                href: `/course/${id}`,
                pathname: seoUrlDescription
                  ? `/course/${id}/${seoUrlDescription}`
                  : `/course/${id}`,
              }}
            >
              <div className="relative flex cursor-pointer flex-col overflow-hidden rounded bg-white shadow-md md:flex-row md:p-5 md:pl-10">
                <img
                  loading="lazy"
                  src={image ?? "images/nc-img.png"}
                  alt="photo"
                  className="w-full rounded-t object-cover md:ml-7 md:w-60 xl:rounded"
                />
                <div className="w-full p-5 px-3 pb-14 text-black-450 md:p-0 md:text-lg">
                  <h3 className="font-bold">{name ?? title}</h3>
                  <div className="text-sm md:px-3">
                    <div className="my-3 space-y-3 text-xs text-[#999696]">
                      <div className="flex">
                        <Clock className="ml-2 fill-[#999696]" />
                        <p>{convertToJalali(startDate)}</p>
                      </div>
                      <div className="flex">
                        <Profile className="ml-2 fill-[#999696]" />
                        <p>
                          {teacherNames} ـ {getClassFormat(courseType)}
                        </p>
                      </div>
                    </div>
                    <div className="flex w-full items-end justify-between">
                      <div>
                        {price == 0 ? (
                          "رایگان"
                        ) : (
                          <>
                            <span className="ml-1 whitespace-nowrap text-sm md:ml-5 md:text-base">
                              {discount && commafy(discount)} تومان
                            </span>
                            <span className="whitespace-nowrap text-xs text-[#999696] line-through md:text-sm">
                              {price && commafy(price)} تومان
                            </span>
                          </>
                        )}{" "}
                      </div>
                      <Button
                        // isLoading={isLoading}
                        // onClick={(e) => {
                        //     e.stopPropagation();
                        //     handlePay({ discount, price, id });
                        // }}
                        CClassName="bg-blue-550 ml-5 whitespace-nowrap md:text-base text-sm md:px-3 px-3 py-[10px] text-white"
                      >
                        افزودن به سبد خرید
                      </Button>
                    </div>
                  </div>
                  <div
                    style={{
                      clipPath: "polygon(17% 0, 46% 100%, 0 100%, 0 0)",
                      background:
                        "linear-gradient(270deg, #366494 0%, #0480D4 50%, #27B2BC 100%)",
                    }}
                    className="absolute left-0 top-0 hidden h-full w-28 rounded-tl-md md:flex"
                  />
                  <div
                    style={{
                      clipPath: "polygon(46% 0, 16% 100%, 0 100%, 0 0)",
                      background:
                        "linear-gradient(270deg, rgba(54, 100, 148, 0.31) 0%, rgba(4, 128, 212, 0.35) 50%, rgba(39, 178, 188, 0.335) 100%)",
                    }}
                    className="absolute left-0 top-0 hidden h-full w-32 rounded-tl-md md:flex"
                  />
                  <div
                    style={{
                      clipPath: "polygon(100% 79%, 100% 100%, 0 100%, 0 86%)",
                      background:
                        "linear-gradient(270deg, #366494 0%, #0480D4 50%, #27B2BC 100%)",
                    }}
                    className="absolute left-0 bottom-0 flex h-36 w-full md:hidden"
                  />
                  <div
                    style={{
                      clipPath: "polygon(100% 90%, 100% 100%, 0 100%, 0 78%)",
                      background:
                        "linear-gradient(270deg, rgba(54, 100, 148, 0.31) 0%, rgba(4, 128, 212, 0.35) 50%, rgba(39, 178, 188, 0.335) 100%)",
                    }}
                    className="absolute left-0 bottom-0 flex h-44 w-full md:hidden"
                  />
                </div>
              </div>
            </Link>
          )
        )}
      </div>
    </div>
  );
};

export default Prerequisites;
